export const educationData = [
    {
        id: 1,
        category: "education",
        date: `Jan 2021 - Aug 2024`,
        title: "Business Information Technology",
        place: "Kwame Nkrumah University of Science and Technology",
        desc: "Relevant Courses - Database Management for Business , Computer Operating System , Introduction to Programming , Mobile Application Design , Introduction to Business Analytics  , Management Information Systems , Internet Technology for Business , Networking & Security , Web Application Design , Decsion Support Systems , System Analysis Design",
        image: require("../../assets/knust.png")
    },
   
    
    {
        id: 2,
        category: "education",
        date: "Feb 2022 -  Mar 2023",
        title: "Full Stack Software Engineering ",
        place: "Alx Africa (Remote)",
        desc: "Full Stack Software Engineering -   HTML , CSS , JavaScript , Typescript , React , Node ,  Python , C# , Devops , Git  .",
        image: require("../../assets/alx.jpeg")

    },

    {
        id: 4,
        category: "education",
        date: "Sep 2019 - Dec 2020",
        title: "Diploma in Information Technology",
        place: "Future Starts Now Gambia",
        desc: "Certificate and Diploma in Information Technology - Microsoft Word , Microsoft Excel , Microsoft Powerpoint , Microsoft Access",
        image: require("../../assets/future.png")

    },
    {
        id: 5,
        category: "education",
        date: "Oct 2016 - Jun 2019",
        title: "Commerce",
        place: "Nusrat Senior Secondary School",
        desc: "West African  Examination Council (WASSCE) - Mathematics , Core Science , Agricultural Science , English Language , Financial Accounting , Cost Accounting , Economics ,  Geography, Commerce .",
        image: require("../../assets/nusrat.webp")

    },
    {
        id: 14,
        category: "work",
        date: "Jan 2026 - Present",
        title: "Application Developer",
        place: "Medical Research Council The Gambia",
        desc: "",
        image: require("../../assets/mrc.jpeg")

    },

     {
        id: 15,
        category: "work",
        date: "Feb 2025 - Aug 2025",
        title: "Software Engineer",
        place: "Nafa Financial Services",
        desc: "Building fintech mobile applications using Flutter, clean architecture, and GraphQL to support digital financial services. Developing scalable and efficient solutions to enhance customer experience. Creating secure and dynamic platforms that streamline financial operations for businesses.",
        image: require("../../assets/nafa.png")

    },



    {
        id: 7,
        category: "work",
        date: `Oct 2023 - Dec 2023`,
        title: "Software Engineer Intern",
        place: "Insist Global ",
        desc: "Developed API's using Node , express , Postgres and MongoDB while adhering to the clean architecture and design patterns. Building robust frontend applications using React , Next Js and Tailwind utilising for application containerisations.",
        image: require("../../assets/insist.png")
    },

    {
        id: 8,
        category: "work",
        date: `Sep 2022 - Aug 2024`,
        title: "Software Engineer",
        place: "Natures Specialty Foods",
        desc: "Created an e-commerce website from scratch, enhanced user experience, managed content updates, and improved site performance, all while boosting consumer awareness.",
        image: require("../../assets/Nature's Logo White .png")

    },
    {
        id: 9,
        category: "work",
        date: `Oct 2021 - Dec 2021`,
        title: "Software Engineer Intern",
        place: "Qcell",
        desc: "Created single page applications, dashboards, CRUD applications, and full-stack web applications. Acquired experience in Software Development and technical environments, including exposure to GitHub and Database Management.",
        image: require("../../assets/qcell.png")
    },


];